import { useState } from 'react'
import Button from '../../Components/Button'
import type { IItem } from '../../Items/IItem'
import useItem from '../../Items/Item/Item.hook'
import { selectItemWipById } from '../../Items/Item/Item.selector'
import { useTranslation } from 'react-i18next'
import { closeModal } from '../../UI/UI.reducer'
import { updateItem } from '../../Items/Items.action'
import { useAppDispatch, useAppSelector } from '../../Store/hooks'
import { Category } from '../../Items/ItemForm/Category/Category'

export const EditCategoryModal = () => {
  const { t } = useTranslation()

  const itemIdToUpdate = useAppSelector((state) => state.ui.id)

  const itemfromApi: IItem = useAppSelector((state) =>
    selectItemWipById(state, itemIdToUpdate)
  )
  const [isDisabledSave, setSaveDisabled] = useState(false)
  const { item, updateStateByItem } = useItem(itemfromApi)
  const dispatch = useAppDispatch()

  const updateCurrentItem = (item: IItem) => {
    dispatch(updateItem(item, false))
  }

  if (!item) return null

  return (
    <div>
      <div className="pt-2 px-1 pb-7">
        <Category
          item={item}
          updateStateByItem={(e, v) => {
            updateStateByItem(e, v, dispatch)
          }}
        />
      </div>
      <div className="modal-footer modal-footer-sticky border-top mt-7">
        <div className="row">
          <div className="col-12">
            <Button
              testId="create-item"
              clickHandler={() => {
                updateCurrentItem(item)
                setSaveDisabled(true)
                dispatch(closeModal())
              }}
              variant={isDisabledSave ? 'disable' : 'primary'}
              size="normal"
              text={t('modal_editCategory_button')}
              disable={isDisabledSave}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
